import { QUERY_KEY_PARTICIPANTS, QUERY_KEY_PARTICIPANTS_FOR_GROUPS_BY_SEARCH } from "../../const/queryKey";
import { useQuery } from "react-query";
import { queryOptions } from "./queryOptions";
import { useAppConfigurationSelector, useMsTeamsSelector, useTrack } from "front";
import { IContact } from "../../interfaces/IContact/IContact";
import { getAllParticipantsForGroupsBySearch, getParticipantFromGroup } from "../../apis/actions/participantsAction";
import { IQueryName } from "interfaces/IQueryName/IQueryName";

export const useParticipantsCache = (groupId: string | undefined, noRequest: boolean, searchPattern?: string, firstLetter?: string) => {
  const { appId } = useAppConfigurationSelector("appId");
  const { tenantId } = useMsTeamsSelector("tenantId");
  const { trackItAsync } = useTrack();

  const queryParticipants = useQuery<IContact[]>([QUERY_KEY_PARTICIPANTS, appId, groupId, tenantId, noRequest], trackItAsync(IQueryName.QUERY_PARTICIPANTS, getParticipantFromGroup), {
    ...queryOptions,
    enabled: !!appId || !!groupId,
    staleTime: Infinity,
    refetchOnMount: false,
  });

  const queryParticipantsForGroupBySearch = useQuery<IContact[]>([QUERY_KEY_PARTICIPANTS_FOR_GROUPS_BY_SEARCH, appId, searchPattern, firstLetter, tenantId], trackItAsync(IQueryName.QUERY_PARTICIPANTS_FOR_GROUPS_BY_SEARCH, getAllParticipantsForGroupsBySearch), {
    ...queryOptions,
    enabled: !!appId || !!searchPattern || !!firstLetter,
    staleTime: Infinity,
    refetchOnMount: false,
  });
  
  return { queryParticipants, queryParticipantsForGroupBySearch };
};
